import constant from '@/constant.js'
import util from '@/util.js'

export default {
  getJournals: function (filter, cb) {
    var data = { isOpen: true, sort: 'addTime', desc: true }
    if (filter) {
      data.page = Number(filter.page)
      data.count = Number(filter.limit)
    }
    util.apiHandler('post', `${constant.API_ROOT}/article/findByCondition`, data, cb)
  },
  getJournalTotal: function (cb) {
    var data = { isOpen: true }
    util.apiHandler('post', `${constant.API_ROOT}/article/countByCondition`, data, cb)
  },
  getJournal: function (id, cb) {
    util.apiHandler('post', `${constant.API_ROOT}/article/findbyid/${id}`, null, cb)
  },
  getJournalByLink: function (link, cb) {
    util.apiHandler('post', `${constant.API_ROOT}/article/findbylink/${link}`, null, cb)
  },
  getJournalGallery: function (id, cb) {
    var data = {
      articleId: id,
      sort: 'groupId',
      desc: false
    }
    util.apiHandler('post', `${constant.API_ROOT}/articleGallery/findByCondition`, data, cb)
  }
}
